import { render, staticRenderFns } from "./ProfitAndLossIncomeDataTableReadOnly.vue?vue&type=template&id=6ba31657"
import script from "./ProfitAndLossIncomeDataTableReadOnly.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossIncomeDataTableReadOnly.vue?vue&type=script&lang=js"
import style0 from "./ProfitAndLossIncomeDataTableReadOnly.vue?vue&type=style&index=0&id=6ba31657&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports